import { invoke } from "@tauri-apps/api/core";
import type { ConversationRuntimePurgeTarget } from "@/api/conversations";
import { isTauri } from "@/lib/is-tauri";

export async function purgeChatRuntimeStorage(
  targets: ConversationRuntimePurgeTarget[],
): Promise<void> {
  if (!isTauri()) throw new Error("Chat deletion requires the desktop app");
  const purged = await invoke<number>("purge_chat_runtime_storage", { targets });
  if (purged !== targets.length) {
    throw new Error("Not every chat runtime was purged");
  }
}
